import { NodeKinds } from "interfaces/enums";

export const getAccessoriesData = (selectedAccessories, accessoryGroups) => {
  if (!selectedAccessories) {
    return [];
  }

  return selectedAccessories.map((item) => ({
    seriesId: item.seriesId,
    accessoryId: item.accessoryId,
    accessoryGroupId: item.accessoryGroupId,
    pimId: item.pimId,
    currentPresentation: item.currentPresentation,
    optionStates: item.optionStates,
    title: getAccessoryTitle(item, accessoryGroups),
    currentStrategyId: item.currentStrategyId,
  }));
};

export const getAccessoryFromGroup = (accessory, accessoryGroups) => {
  const foundAccessoryGroup = accessoryGroups.find(
    (group) => group?.id === accessory.accessoryGroupId,
  );

  if (!foundAccessoryGroup) {
    return null;
  }

  const foundAccessory = foundAccessoryGroup.accessories.find(
    (acc) => acc?.accessoryId === accessory.accessoryId,
  );

  if (!foundAccessory) {
    return null;
  }

  return foundAccessory;
};

export const getAccessoryTitle = (accessory, accessoryGroups) => {
  const foundAccessory = getAccessoryFromGroup(accessory, accessoryGroups);

  return (
    foundAccessory?.ordercode?.key ||
    foundAccessory.seriesName?.split("-")[0] ||
    ""
  );
};

export const prepareNodesForProductWithAccessories = ({
  accessoriesData,
  quantity,
  requestParams,
}) => {
  const selectedAccessories = [];
  const accessories =
    accessoriesData &&
    accessoriesData.map(({ title, ...accessoryItem }) => {
      selectedAccessories.push(accessoryItem);
      return {
        accessoryGroupId: accessoryItem.accessoryGroupId,
        accessoryId: accessoryItem.accessoryId,
        quantity,
        active: true,
        parentId: "accessory-parent-id",
        id: "new-id",
        kind: NodeKinds.PRODUCT_ACCESSORY,
        productName: title,
        orderCode: {
          seriesId: accessoryItem.seriesId,
          state: { optionStates: accessoryItem.optionStates },
          currentStrategyId: accessoryItem.currentStrategyId,
        },
        presentation: accessoryItem.currentPresentation,
        pimId: accessoryItem.pimId,
      };
    });

  return {
    data: {
      active: true,
      partiallyVisible: false,
      quantity,
      parentId: "dummy-parent-id",
      kind: NodeKinds.PRODUCT,
      nodes: accessories || [],
      selectedAccessories,
      ...requestParams,
    },
  };
};

// this function makes sense till createProduct mutation does not return infoText and ordercode in selectedAccessories field
export const updateSelectedAccessories = ({
  initSelectedAccessories,
  accessoryGroups,
}) =>
  initSelectedAccessories.map((selectedAccessory) => {
    const needsUpdate =
      !selectedAccessory.infoText || !selectedAccessory.ordercode;

    if (!needsUpdate) {
      return selectedAccessory;
    }

    const accessoryGroup = accessoryGroups.find(
      (group) => group.id === selectedAccessory.accessoryGroupId,
    );

    if (!accessoryGroup) {
      return selectedAccessory;
    }

    const accessoryInAccessoryGroups = accessoryGroup.accessories.find(
      (accessory) =>
        accessory.accessoryId === selectedAccessory.accessoryId &&
        accessory.currentPresentation === selectedAccessory.currentPresentation,
    );

    if (!accessoryInAccessoryGroups) {
      return selectedAccessory;
    }

    return {
      ...selectedAccessory,
      infoText:
        selectedAccessory.infoText || accessoryInAccessoryGroups.infoText,
      ordercode:
        selectedAccessory.ordercode || accessoryInAccessoryGroups.ordercode,
    };
  });
